// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { SxProps, TextField, TextFieldProps } from "@mui/material";
import { Theme } from "@mui/system";
import { DateTimePicker } from "@mui/x-date-pickers";
import { Control, Controller, ControllerProps } from "react-hook-form";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';
import 'dayjs/locale/tr' // import Türkçe dil desteği
import dayjs from 'dayjs'

dayjs.locale('tr') // use Türkçe dil desteği global olarak


export type DateTimeControlProps = {
  label: string;
} & TextFieldProps;

export interface DateTimePickerControlProps<TFormFields>
  extends DateTimeControlProps,
  Pick<ControllerProps, "rules"> {
  control: Control<TFormFields, object>;
  helperText?: string;
  maxDate?: dayjs.Dayjs;
  minDate?: dayjs.Dayjs;
  type?: React.HTMLInputTypeAttribute | undefined;
  id: Path<TFormFields>;
  label?: string;
  defaultValue?: any;
  size?: "medium" | "small";
  sx?: SxProps<Theme>;
}

export function DateTimePickerControl<TFormFields>(
  props: DateTimePickerControlProps<TFormFields>
) {
  const {
    control,
    type,
    label,
    rules,
    size = "medium",
    sx,
    defaultValue,
    maxDate,
    minDate,
    ...textFieldProps
  } = props;

  return (
    <Controller
      control={control}
      name={textFieldProps.id}
      rules={rules}
      defaultValue={defaultValue ?? null}
      render={({ field: { onChange, name, value }, fieldState: { error } }) => {
        return (
          <LocalizationProvider dateAdapter={AdapterDayjs} locale="tr">
            <DateTimePicker
              sx={sx}
              size={size}
              label={label}
              value={value}
              onChange={onChange}
              slotProps={{
                textField: {
                  error: !!error,
                  helperText: error?.message || "",
                },
              }}
              minDate={minDate}
              maxDate={maxDate}
              type={type}
              format={"DD.MM.YYYY HH:mm"}
              ampm={false}
              viewRenderers={{
                hours: renderTimeViewClock,
                minutes: renderTimeViewClock,
                seconds: renderTimeViewClock,
              }}
            />
          </LocalizationProvider>
        );
      }}
    />
  );
}